import { getState } from '~src/state';
import { displayBackgroundManager } from '~src/sidebar/index';

export const removeTagBackgroundFromCache = (imageItemId, tagId) => {
  const currentTag = getState('sidebarCurrentBackgroundsTag', 'NO_TAG');
  const backgroundItem = window.editorConfig.sidebarBackgrounds[
    currentTag
  ].items.find((item) => item.objectId === imageItemId);

  backgroundItem.tags = backgroundItem.tags.filter(
    (tag) => tag.objectId !== tagId
  );

  displayBackgroundManager(imageItemId);
};
